<template>
  <v-layout wrap>
    <v-flex xs12 v-show="$apollo.loading && showLoader">
      <v-layout justify-center>
        <v-progress-circular
          indeterminate
          :size="50"
          color="primary"
        ></v-progress-circular>
      </v-layout>
    </v-flex>
    <v-flex xs12>
      <v-layout>
        <v-slide-y-transition>
          <v-flex xs12 v-show="!$apollo.loading || !showLoader">
            <v-row>
              <v-col cols="12">
                <v-container fluid py-0>
                  <v-row align="center">
                    <v-icon large>{{
                      supplierTypeIcon(supplierData.serviceType)
                    }}</v-icon>

                    <h1 class="headline">
                      {{ supplierData.serviceType }} /
                      {{
                        supplierData.name != ""
                          ? supplierData.name
                          : "New Supplier"
                      }}
                    </h1>

                    <v-spacer></v-spacer>

                    <v-row justify="end" align="center">
                      <one-page-view-switch
                        setting-name="supplierOnePageView"
                        v-model="onePage"
                      />
                      <div class="px-3">
                        <supplier-details-settings
                          :visible-tabs="tabs"
                          @change="onSettingsChange"
                        ></supplier-details-settings>
                      </div>
                    </v-row>
                  </v-row>
                </v-container>
              </v-col>
            </v-row>
            <v-layout v-if="onePage">
              <v-expansion-panels v-model="panels" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <h5 class="headline">Details</h5>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <supplier-details-form
                      :supplier="supplierData"
                      @onSave="saveListener"
                      @marketplace-change="onMarketPlaceChange"
                    ></supplier-details-form>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel
                  :disabled="disabled"
                  v-if="tabIsVisible('financial')"
                >
                  <v-expansion-panel-header>
                    <h5 class="headline">Financial</h5>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <supplier-financial-details
                      :supplier="supplierData"
                      @onSave="saveListener"
                    ></supplier-financial-details>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel
                  :disabled="disabled"
                  v-if="tabIsVisible('services')"
                >
                  <v-expansion-panel-header>
                    <h5 class="headline">Services</h5>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <service-list
                      :show-title="false"
                      @onChange="onServicesChange"
                      @onFlagToggle="onServiceFlagToggle"
                      :services="servicesList"
                      :supplier-id="supplier.id"
                      :supplier-type="supplier.serviceType"
                    ></service-list>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel
                  :disabled="disabled"
                  v-if="tabIsVisible('rates')"
                >
                  <v-expansion-panel-header>
                    <h5 class="headline">Rates</h5>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <supplier-rates-edit :supplierId="id"></supplier-rates-edit>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel
                  :disabled="disabled"
                  v-if="tabIsVisible('extras')"
                >
                  <v-expansion-panel-header>
                    <h5 class="headline">Extras</h5>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <supplier-extras
                      :show-title="false"
                      :supplier-id="supplier.id"
                    ></supplier-extras>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel v-if="tabIsVisible('flights')">
                  <v-expansion-panel-header>
                    <h5 class="headline">Flights</h5>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content v-if="tabIsVisible('flights')">
                    <flights-list
                      :show-title="false"
                      :customFilters="{ supplierId: supplier.id }"
                    ></flights-list>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel
                  :disabled="disabled"
                  v-if="tabIsVisible('contents')"
                >
                  <v-expansion-panel-header>
                    <h5 class="headline">Contents</h5>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <contents
                      v-if="id"
                      :owner-id="id"
                      :dialog-title="contentDialogTitle"
                      owner-name="SUPPLIER"
                      :view-only="
                        $store.getters.hasAccessTo('suppliers:view_only')
                      "
                    ></contents>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel
                  :disabled="disabled"
                  v-if="tabIsVisible('discounts')"
                >
                  <v-expansion-panel-header>
                    <h5 class="headline">Discounts</h5>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <supplier-discounts
                      :services="servicesList"
                      :show-title="false"
                      :supplier-id="supplier.id"
                    ></supplier-discounts>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel
                  :disabled="disabled"
                  v-if="tabIsVisible('taxes')"
                >
                  <v-expansion-panel-header>
                    <h5 class="headline">Taxes</h5>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <supplier-taxes
                      :services="servicesList"
                      :show-title="false"
                      :supplier-id="supplier.id"
                    ></supplier-taxes>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel
                  :disabled="disabled"
                  v-if="tabIsVisible('allocations')"
                >
                  <v-expansion-panel-header>
                    <h5 class="headline">Allocations</h5>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <supplier-allocations
                      :services="servicesList"
                      :show-title="false"
                      :supplier-id="supplier.id"
                    ></supplier-allocations>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel
                  :disabled="disabled"
                  v-if="tabIsVisible('closeouts')"
                >
                  <v-expansion-panel-header>
                    <h5 class="headline">Close Outs</h5>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <supplier-closeouts
                      :show-title="false"
                      :supplier-id="supplier.id"
                      :services="servicesList"
                    ></supplier-closeouts>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel
                  :disabled="disabled"
                  v-if="tabIsVisible('custom_fields')"
                >
                  <v-expansion-panel-header>
                    <h5 class="headline">Custom Fields</h5>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <custom-fields-form
                      :show-title="false"
                      v-model="supplierData.customFields"
                      @onSave="saveListener"
                      :hide-save="
                        $store.getters.hasAccessTo('suppliers:view_only')
                      "
                    ></custom-fields-form>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel
                  :disabled="disabled"
                  v-if="tabIsVisible('histories')"
                >
                  <v-expansion-panel-header>
                    <h5 class="headline">Histories</h5>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <history-list
                      :custom-filters="historiesFilter"
                      refNameColumns="suppliersHistories"
                      :cached-filters="false"
                      :show-title="false"
                    ></history-list>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel
                  :disabled="disabled"
                  v-if="tabIsVisible('comps')"
                >
                  <v-expansion-panel-header>
                    <h5 class="headline">Supplier Comps</h5>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <supplier-comps
                      :supplier-id="id"
                      :supplier-type="supplier.serviceType"
                      :services="servicesList"
                    ></supplier-comps>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel
                  :disabled="disabled"
                  v-if="tabIsVisible('service_notes')"
                >
                  <v-expansion-panel-header>
                    <h5 class="headline">Service Notes</h5>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <service-notes
                      :supplier-id="id"
                      :services="servicesList"
                    ></service-notes>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel
                  :disabled="disabled"
                  v-if="tabIsVisible('linked_services')"
                >
                  <v-expansion-panel-header>
                    <linked-services
                      :supplier="supplier"
                      :services="servicesList"
                    />
                  </v-expansion-panel-header>
                </v-expansion-panel>
                <v-expansion-panel
                  :disabled="disabled"
                  v-if="tabIsVisible('supplier_portal')"
                >
                  <v-expansion-panel-header>
                    <h5 class="headline">Supplie Portal</h5>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <supplier-portal
                      :supplier-id="id"
                      :services="servicesList"
                    />
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel
                  :disabled="disabled"
                  v-if="
                    tabIsVisible('tasks') &&
                    this.$store.getters.hasAccessTo('plugins:task_tracker')
                  "
                >
                  <v-expansion-panel-header>
                    <h5 class="headline">Tasks</h5>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <task-tracker-list :supplier="supplier"></task-tracker-list>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-layout>
            <v-layout v-else>
              <v-tabs
                class="elevation-2 gradient-bg"
                background-color="transparent"
                centered
                dark
              >
                <v-tab key="details" ripple>Details</v-tab>
                <v-tab-item key="details">
                  <supplier-details-form
                    :supplier="supplierData"
                    @onSave="saveListener"
                    @marketplace-change="onMarketPlaceChange"
                  ></supplier-details-form>
                </v-tab-item>
                <template v-if="tabIsVisible('financial')">
                  <v-tab key="finacial" ripple :disabled="disabled"
                    >Financial</v-tab
                  >
                  <v-tab-item key="finacial">
                    <supplier-financial-details
                      :supplier="supplierData"
                      @onSave="saveListener"
                    ></supplier-financial-details>
                  </v-tab-item>
                </template>
                <template v-if="tabIsVisible('services')">
                  <v-tab key="services" ripple :disabled="disabled"
                    >Services</v-tab
                  >
                  <v-tab-item key="services">
                    <service-list
                      @onChange="onServicesChange"
                      @onFlagToggle="onServiceFlagToggle"
                      :services="servicesList"
                      :supplier-id="supplier.id"
                      :supplier-type="supplier.serviceType"
                    ></service-list>
                  </v-tab-item>
                </template>
                <template v-if="tabIsVisible('rates')">
                  <v-tab key="rates" ripple :disabled="disabled">Rates</v-tab>
                  <v-tab-item key="rates">
                    <v-card flat>
                      <v-card-text>
                        <supplier-rates-edit
                          :supplierId="id"
                        ></supplier-rates-edit>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </template>
                <template v-if="tabIsVisible('extras')">
                  <v-tab key="extras" ripple :disabled="disabled">Extras</v-tab>
                  <v-tab-item key="extras">
                    <v-card flat>
                      <v-card-text>
                        <supplier-extras
                          :supplier-id="supplier.id"
                        ></supplier-extras>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </template>
                <template v-if="tabIsVisible('flights')">
                  <v-tab key="flights" ripple :disabled="disabled"
                    >Flights</v-tab
                  >
                  <v-tab-item key="flights">
                    <v-card flat>
                      <v-card-text>
                        <flights-list
                          :customFilters="{ supplierId: supplier.id }"
                        ></flights-list>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </template>
                <template v-if="tabIsVisible('contents')">
                  <v-tab key="contents" ripple :disabled="disabled"
                    >Contents</v-tab
                  >
                  <v-tab-item key="contents">
                    <v-card flat>
                      <v-card-text>
                        <contents
                          v-if="id"
                          :owner-id="id"
                          owner-name="SUPPLIER"
                          :view-only="
                            $store.getters.hasAccessTo('suppliers:view_only')
                          "
                        ></contents>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </template>
                <template v-if="tabIsVisible('discounts')">
                  <v-tab key="discounts" ripple :disabled="disabled"
                    >Discounts</v-tab
                  >
                  <v-tab-item key="discounts">
                    <v-card flat>
                      <v-card-text>
                        <supplier-discounts
                          :services="servicesList"
                          :supplier-id="supplier.id"
                        ></supplier-discounts>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </template>
                <template v-if="tabIsVisible('taxes')">
                  <v-tab key="taxes" ripple :disabled="disabled">Taxes</v-tab>
                  <v-tab-item key="taxes">
                    <v-card flat>
                      <v-card-text>
                        <supplier-taxes
                          :services="servicesList"
                          :supplier-id="supplier.id"
                        ></supplier-taxes>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </template>
                <template v-if="tabIsVisible('allocations')">
                  <v-tab key="allocations" ripple :disabled="disabled"
                    >Allocations</v-tab
                  >
                  <v-tab-item key="allocations">
                    <v-card flat>
                      <v-card-text>
                        <supplier-allocations
                          :services="servicesList"
                          :supplier-id="supplier.id"
                        ></supplier-allocations>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </template>
                <template v-if="tabIsVisible('closeouts')">
                  <v-tab key="closeouts" ripple :disabled="disabled"
                    >Closeouts</v-tab
                  >
                  <v-tab-item key="closeouts">
                    <v-card flat>
                      <v-card-text>
                        <supplier-closeouts
                          :supplier-id="supplier.id"
                          :services="servicesList"
                        ></supplier-closeouts>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </template>
                <template v-if="tabIsVisible('custom_fields')">
                  <v-tab key="customFields" ripple :disabled="disabled"
                    >Custom Fields</v-tab
                  >
                  <v-tab-item key="customFields">
                    <custom-fields-form
                      v-model="supplierData.customFields"
                      @onSave="saveListener"
                      :hide-save="
                        $store.getters.hasAccessTo('suppliers:view_only')
                      "
                    ></custom-fields-form>
                  </v-tab-item>
                </template>
                <template v-if="tabIsVisible('histories')">
                  <v-tab key="histories" ripple :disabled="disabled"
                    >Histories</v-tab
                  >
                  <v-tab-item key="histories">
                    <v-container fluid>
                      <history-list
                        :customFilters="historiesFilter"
                        refNameColumns="suppliersHistories"
                        :cachedFilters="false"
                      ></history-list>
                    </v-container>
                  </v-tab-item>
                </template>
                <template v-if="tabIsVisible('comps')">
                  <v-tab key="comps" ripple :disabled="disabled"
                    >Supplier Comps</v-tab
                  >
                  <v-tab-item key="comps">
                    <v-container fluid>
                      <supplier-comps
                        :supplier-id="id"
                        :supplier-type="supplierData.serviceType"
                        :services="servicesList"
                      ></supplier-comps>
                    </v-container>
                  </v-tab-item>
                </template>
                <template v-if="tabIsVisible('service_notes')">
                  <v-tab key="service-notes" ripple :disabled="disabled"
                    >Service Notes</v-tab
                  >
                  <v-tab-item key="service-notes">
                    <v-container fluid>
                      <service-notes
                        :supplier-id="id"
                        :services="servicesList"
                      ></service-notes>
                    </v-container>
                  </v-tab-item>
                </template>
                <template v-if="tabIsVisible('linked_services')">
                  <v-tab key="linked-services" ripple :disabled="disabled"
                    >Linked Services</v-tab
                  >
                  <v-tab-item key="linked-services">
                    <v-container fluid>
                      <linked-services
                        :supplier="supplier"
                        :services="servicesList"
                      />
                    </v-container>
                  </v-tab-item>
                </template>
                <template v-if="tabIsVisible('supplier_portal')">
                  <v-tab key="supplier-portal" ripple :disabled="disabled"
                    >Supplier Portal</v-tab
                  >
                  <v-tab-item key="supplier-portal">
                    <v-container fluid>
                      <supplier-portal-settings
                        :supplier-id="id"
                        :supplier="supplier"
                      />
                    </v-container>
                  </v-tab-item>
                </template>
                <template
                  v-if="
                    tabIsVisible('tasks') &&
                    this.$store.getters.hasAccessTo('plugins:task_tracker')
                  "
                >
                  <v-tab key="tasks" ripple :disabled="disabled">Tasks</v-tab>
                  <v-tab-item key="tasks">
                    <v-container fluid>
                      <task-tracker-list
                        :supplier="supplier"
                      ></task-tracker-list>
                    </v-container>
                  </v-tab-item>
                </template>
              </v-tabs>
            </v-layout>
            <v-layout>
              <back-to-list-btn
                :route="backRoute"
                v-if="!isModal"
              ></back-to-list-btn>
            </v-layout>
          </v-flex>
        </v-slide-y-transition>
      </v-layout>
      <div v-if="debug">
        {{ supplierData.propagateMarketplace }} -- {{ supplierData }}
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import {
  SUPPLIER_RECORD_QUERY,
  SUPPLIER_UPDATE_MUTATION,
  SUPPLIER_CREATE_MUTATION,
} from "../../../constants/graphql";
import SupplierDetailsForm from "./SupplierDetailsForm";
import SupplierFinancialDetails from "./SupplierFinancialDetails";
import CustomFieldsForm from "../shared/CustomFieldsForm";
import ServiceList from "./services/ServiceList";
import SupplierExtras from "./extras/SupplierExtras";
import SupplierDiscounts from "./discounts/SupplierDiscounts";
import SupplierTaxes from "./taxes/SupplierTaxes";
import SupplierAllocations from "./allocations/SupplierAllocations";
import SupplierCloseouts from "./closeouts/SupplierCloseouts";
import SupplierRatesEdit from "./supplier-rates/edit/SupplierRatesEdit";
import Contents from "../shared/contents/Contents";
import EventBus from "../../../store/event-bus";
import { SupplierTypeIconMixin } from "../../../mixins/SupplierTypeIconMixin";
import UnsavedChangesMixin from "../../../mixins/UnsavedChangesGuard";
import BackToListBtn from "../shared/BackToListBtn";
import OnePageViewSwitch from "../shared/OnePageViewSwitch";
import { removeGQLTypename } from "../../../helpers/index";
import HistoryList from "../plugins/histories/HistoryList";
import SupplierComps from "./comps/SupplierComps";
import TaskTrackerList from "../plugins/task-tracker/TaskTrackerList";
import SupplierDetailsSettings from "./SupplierDetailsSettings.vue";
import ServiceNotes from "./service-notes/ServiceNotes.vue";
import FlightsList from "../plugins/flights/FlightsList.vue";
import SupplierPortalSettings from "./portal/SupplierPortalSettings.vue";
import LinkedServices from "./linked-services/LinkedServices.vue";
export default {
  name: "SupplerDetails",
  props: {
    supplierId: {
      type: String,
      default: () => "",
    },
    isModal: {
      type: Boolean,
      dafault: () => false,
    },
  },
  components: {
    SupplierRatesEdit,
    SupplierDetailsForm,
    ServiceList,
    SupplierExtras,
    SupplierDiscounts,
    SupplierTaxes,
    SupplierAllocations,
    SupplierCloseouts,
    CustomFieldsForm,
    Contents,
    SupplierFinancialDetails,
    BackToListBtn,
    OnePageViewSwitch,
    HistoryList,
    SupplierComps,
    TaskTrackerList,
    SupplierDetailsSettings,
    ServiceNotes,
    FlightsList,
    SupplierPortalSettings,
    LinkedServices,
  },
  mixins: [SupplierTypeIconMixin, UnsavedChangesMixin],
  data() {
    const defaultTabs = [
      "details",
      "finances",
      "services",
      "rates",
      "extras",
      "flights",
      "contents",
    ];
    return {
      debug: false,
      id: this.supplierId != "" ? this.supplierId : this.$route.params.id,
      defaultTabs: defaultTabs,
      onePage: false,
      panels: [0],
      supplier: {},
      supplierData: {
        id: null,
        name: "",
        altName: "",
        notInUse: false,
        noLetter: false,
        noVoucher: false,
        isHeadOffice: false,
        extrasChildPrice: false,
        serviceType: this.$route.params.serviceType
          ? this.$route.params.serviceType.toUpperCase()
          : "",
        currencyCode: "",
        pickup: "",
        dropoff: "",
        zone: "",
        tags: "",
        languageId: this.$store.getters.userConfig
          ? this.$store.getters.userConfig.defaultLanguageId
          : "",
        notes: "",
      },
      showLoader: true,
      childExtraPricesCb: null,
      showChildExtraPriceConfirmation: false,
      tabs: this.$store.getters.localSettings(
        "supplierDetailsTabs",
        defaultTabs
      ),
    };
  },
  computed: {
    viewOnly() {
      return this.$store.getters.hasAccessTo("suppliers:view_only");
    },
    tasksAvailable() {
      return this.$store.getters.hasAccessTo("suppliers:tasks");
    },
    visibleTabs() {
      let dt = this.defaultTabs;
      if (this.supplier && this.supplier.serviceType == "TRAVEL") {
        dt.push("flights");
      }
      let visible = this.$store.getters.localSettings("supplierDetailsTabs")
        ? [...this.$store.getters.localSettings("supplierDetailsTabs")]
        : dt;
      if (!this.tasksAvailable) {
        visible = visible.filter((tab) => tab != "tasks");
      }
      //https://tracker.globetrack.ie/issues/8514
      // if (this.viewOnly) {
      //   //https://tracker.globetrack.ie/issues/7530
      //   visible = ["Details"];
      // }
      return visible;
    },

    historiesFilter() {
      return { supplier_id: this.supplier.id };
    },
    featuredImage() {
      return "https://www.pixelstalk.net/wp-content/uploads/2016/06/Hawaii-Wallpapers-HD-Free-Download.jpg";
    },
    servicesList() {
      if (this.supplier && this.supplier.services) {
        return this.supplier.services.edges.map((node) => {
          return { ...node };
        });
      } else {
        return [];
      }
    },
    disabled() {
      return !(
        this.supplier &&
        this.supplier.id &&
        this.supplier.id.toString() != ""
      );
    },
    backRoute() {
      return "/suppliers/" + this.supplierData.serviceType.toLowerCase();
    },
    contentDialogTitle() {
      return this.supplierData ? this.supplierData.name : "Supplier's Content";
    },
  },

  watch: {
    $route(to, from) {
      if (to.params.id) {
        this.id = to.params.id;
        this.showLoader = false;
      }
    },
    supplierId(newId) {
      this.id = newId;
    },
  },

  methods: {
    onMarketPlaceChange(data) {
      this.supplierData.propagateMarketPlace = confirm(
        "Do you want to update the MarketPlace flag for all services and rates?"
      );
    },

    tabIsVisible(key) {
      if (key == "flights") {
        return (
          this.supplier &&
          this.supplier.id &&
          this.supplier.serviceType == "TRAVEL" &&
          this.$store.getters.hasAccessTo("plugins:flights_management", false)
        );
      }
      return (
        this.visibleTabs.indexOf(key) > -1 &&
        this.$store.getters.hasAccessTo(`suppliers:${key}`, true)
      );
    },
    saveListener() {
      this.routeGuard = false;
      if (this.supplierData.id) {
        this.updateSupplier();
      } else {
        this.createSupplier();
      }
    },
    createSupplier() {
      this.$apollo
        .mutate({
          mutation: SUPPLIER_CREATE_MUTATION,
          variables: this.supplierData,
        })
        .then((result) => {
          this.$store.dispatch("showAppSnackbar", { msg: "Supplier Created." });
          //this.id = result.data.createSupplier.id;
          this.$router.replace(
            "/supplier/" + result.data.createSupplier.id + "/details"
          );
        })
        .catch((err) => {
          this.$store.dispatch("showAppSnackbar", {
            msg: err.graphQLErrors[0].message,
            color: "error",
          });
        });
    },
    updateSupplier() {
      this.$apollo
        .mutate({
          mutation: SUPPLIER_UPDATE_MUTATION,
          variables: this.supplierData,
        })
        .then((data) => {
          this.$store.dispatch("showAppSnackbar", { msg: "Supplier updated." });
          this.$apollo.queries.supplier.refetch();
          EventBus.$emit("refetch-supplier-rates");
          this.storeInitState();
        })
        .catch((err) => {
          this.$store.dispatch("showAppSnackbar", {
            msg: err.graphQLErrors[0].message,
            color: "error",
          });
        });
    },
    onServicesChange(data) {
      this.$store.dispatch("showAppSnackbar", { msg: data });
      EventBus.$emit("supplier-services-change");
      this.$apollo.queries.supplier.refetch();
    },
    onServiceFlagToggle(data) {
      // inline flag toggle persisted itself; just confirm, no refetch (avoids
      // the loading spinner + slide-y page transition that looked like a reload)
      this.$store.dispatch("showAppSnackbar", { msg: data });
    },
    onServiceFilter(filter) {
      this.serviceFilter = { ...filter };
    },
    onCustomFieldsChange(data) {
      this.supplierData.customFields = data;
    },
    onSettingsChange(payload) {
      this.$store.dispatch("updateLocalSettings", {
        supplierDetailsTabs: [...payload],
      });
    },
  },
  apollo: {
    supplier: {
      query: SUPPLIER_RECORD_QUERY,
      variables() {
        return {
          id: this.id,
          //serviceFilter: this.serviceFilter,
        };
      },
      fetchPolicy: "network-only",
      skip() {
        return this.$route.name == "Supplier Create";
      },
      result({ data, loader, networkStatus }) {
        //prepare supplier object
        if (data.supplier) {
          const { services, customFields, paymentTerms, ...supplier } =
            data.supplier;
          this.supplierData = {
            ...supplier,
            customFields: customFields.edges.map((i) => ({
              name: i.node.name,
              content: i.node.content,
              typeId: i.node.typeId,
            })),
            paymentTerms: paymentTerms.edges.map(removeGQLTypename),
          };
        }
        this.storeInitState();
      },
    },
  },
};
</script>

<style scoped>
.gradient-bg {
  background: linear-gradient(to right top, #4527a0, #9575cd);
}
</style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/SupplierDetails.vue